import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { getOrders, getAllVendors } from "../../redux/thunk";
import { RootState } from "../../redux/store";
import { IoSearchOutline } from "react-icons/io5";

export const StateGovernmentOrders = () => {
  const [ordersWithUserId, setOrdersWithUserId] = useState([]);
  const [searchedUser, setSearchedUser] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useAppDispatch();
  const { orders } = useAppSelector((store) => store.orders);

  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastPost = currentPage * itemsPerPage;
  const indexOfFirstPost = indexOfLastPost - itemsPerPage;

  useEffect(() => {
    setIsLoading((prev) => !prev);
    dispatch(getOrders()).then(() => {
      setIsLoading((prev) => !prev);
    });
    dispatch(getAllVendors());
  }, [dispatch]);

  useEffect(() => {
    if (orders.length > 0) {
      setOrdersWithUserId(orders.filter((order: any) => order.userId));
    }
  }, [orders]);

  const searchForUsersWithEmail = (email: string) => {
    setSearchedUser(email);
    // Implement your search logic here
    // You might want to filter ordersWithUserId based on email
  };

  return (
    <main>
      <h2 className="font-semibold text-lg">State Government's Orders</h2>
      <div className="relative w-full text-sm my-3">
        <IoSearchOutline className="w-6 h-6 absolute top-[0.6rem] left-2 text-gray-300" />
        <input
          type="search"
          name="searchedUser"
          id="searchedUser"
          value={searchedUser}
          onChange={(e) => searchForUsersWithEmail(e.target.value)}
          placeholder="Search user using email"
          className="border p-2 rounded-md indent-7 w-full"
          disabled={ordersWithUserId.length === 0}
        />
      </div>

      <div className="my-6">
        <span className="float-right">
          <label htmlFor="filter">
            Sort:
            <select
              name="filter"
              id="filter"
              className="border p-2 ml-4 text-sm"
              onChange={(e) => {
                // Implement your filter logic here
              }}
            >
              <option value="">All</option>
              <option value="pending">Pending</option>
              <option value="approved">Approved</option>
              <option value="delivered">Delivered</option>
              <option value="cancel">Canceled</option>
              <option value="rider">Rider</option>
            </select>
          </label>
        </span>
      </div>

      {/* Add your table or list component here */}
      {isLoading && <p>Loading...</p>}

      {/* Add pagination component here if needed */}
    </main>
  );
};
